import { ApplicationTelegramDataDto } from "@entities/auth";

export const getApplicationTelegramData = (): ApplicationTelegramDataDto => {
  const {
    initData,
    initDataUnsafe: {
      auth_date,
      hash,
      user: { id },
    },
  } = window.Telegram.WebApp;

  return {
    auth_date: auth_date,
    hash: hash,
    id: id,
    init_data: initData,
  };
};
